import { render, staticRenderFns } from "./WatchListCard.vue?vue&type=template&id=39901400"
import script from "./WatchListCard.vue?vue&type=script&lang=js"
export * from "./WatchListCard.vue?vue&type=script&lang=js"
import style0 from "./WatchListCard.vue?vue&type=style&index=0&id=39901400&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39901400')) {
      api.createRecord('39901400', component.options)
    } else {
      api.reload('39901400', component.options)
    }
    module.hot.accept("./WatchListCard.vue?vue&type=template&id=39901400", function () {
      api.rerender('39901400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/WatchListCard.vue"
export default component.exports